export default "__VITE_ASSET__48426176__"